export const PlacementDataMapping = {
  Productivity: {
    adUnitIds: [
      11683864,
      11704771,
      11704772,
      11706808,
      11706810,
      11717259,
      11717260,
      11724134,
      11725880,
      11725881,
      11726080,
      11726081,
      11726082,
      11726083,
      11726084,
      11726800,
      11726801,
      11726802,
      11726803,
      11726804,
      11726805,
      11729575,
      11729576,
      11729577,
      11729578,
      11730601,
      549811264,
      391464,
    ],
  },
  HomePages: {
    adUnitIds: [
      365916,
      365917,
      365918,
      366118,
    ],
  },
  Games: {
    adUnitIds: [
      145758516,
    ],
  },
};
